/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, makeStyles, useMediaQuery,
} from '@material-ui/core';
import { map } from 'lodash';
import config from '@/configs/config';

const useItemStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  productImageContainer: {
    maxWidth: 100,
    maxHeight: 100,
    flexShrink: 0,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  productImage: {
    height: '100%',
    width: '100%',
  },
  infoContainer: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 12,
    marginLeft: theme.spacing(1),
  },
  price: {
    flexShrink: 0,
    marginLeft: 'auto',
    paddingLeft: theme.spacing(1),
  },
  name: {
    fontSize: 14,
    fontWeight: 'bold',
  },
}));

export function Item({ data }) {
  const {
    name, price, productNumber, ingredients, expireDay,
  } = data;
  const classes = useItemStyle();

  return (
    <div className={classes.root}>
      <div className={classes.productImageContainer}>
        <img
          src={`${config.RESOURCE_URI}ProductImages/${productNumber}.jpg`}
          className={classes.productImage}
          alt=""
          onError={(e) => {
            e.currentTarget.src = `${config.RESOURCE_URI}provider_default.png`;
          }}
        />
      </div>
      <div className={classes.infoContainer}>
        <span className={classes.name}>{name}</span>
        <div style={{ height: 8 }} />
        {ingredients && <span>{`成分：${ingredients}`}</span>}
        {expireDay && <span>{`保存期限：${expireDay} 天`}</span> }
      </div>
      <span className={classes.price}>{`$${price}`}</span>
    </div>
  );
}

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const useStyle = makeStyles((theme) => ({
  scrollPaper: {
    alignItems: 'flex-end',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
    },
  },
  paper: {
    height: '90%',
  },
  itemsContainer: {
    marginTop: theme.spacing(2),
    position: 'relative',

    '& > * + *': {
      marginTop: theme.spacing(1),
    },
  },
}));

export default ({
  isOpened,
  onClose,
  data,
}) => {
  const classes = useStyle();
  const isUpSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const fullScreen = !isUpSm;
  const { title, itemDict, description } = data;

  return (
    <Dialog
      classes={{
        scrollPaper: classes.scrollPaper,
        paper: classes.paper,
      }}
      open={isOpened}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      fullScreen={fullScreen}
      TransitionComponent={Transition}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        <span>{description}</span>
        <div className={classes.itemsContainer}>
          {map(
            itemDict,
            (product, id) => (
              <div key={id}>
                <Item data={product} />
              </div>
            )
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>關閉</Button>
      </DialogActions>
    </Dialog>
  );
};
